const AG_GRID_LICENSE =
  'CompanyName=Jpmorgan Chase & Co.,LicensedGroup=Multi,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-015836,ExpiryDate=10_June_2022_[v2]_MTY1NDgxNTYwMDAwMA==2d81b8782d02b0b188bc844aa80f96d4';
export default AG_GRID_LICENSE;
